var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-view_carousel",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 C4.44773812,5.52179053e-05 4.00005522,0.447738124 4,1 L4,2 L1,2 C0.447738124,2.00005522 5.52179053e-05,2.44773812 0,3 L0,15 C5.52179053e-05,15.5522619 0.447738124,15.9999448 1,16 L4,16 L4,17 C4.00005522,17.5522619 4.44773812,17.9999448 5,18 L15,18 C15.5522619,17.9999448 15.9999448,17.5522619 16,17 L16,16 L19,16 C19.5522619,15.9999448 19.9999448,15.5522619 20,15 L20,3 C19.9999448,2.44773812 19.5522619,2.00005522 19,2 L16,2 L16,1 C15.9999448,0.447738124 15.5522619,5.52179053e-05 15,0 L5,0 Z M6,2 L14,2 L14,2.8320312 C13.982151,2.9400226 13.982151,3.0502117 14,3.1582031 L14,14.832031 C13.982151,14.9400224 13.982151,15.0502116 14,15.158203 L14,16 L6,16 L6,15.167969 C6.01784905,15.0599776 6.01784905,14.9497884 6,14.841797 L6,3.1679688 C6.01784904,3.0599774 6.01784904,2.9497883 6,2.8417969 L6,2 Z M2,4 L4,4 L4,14 L2,14 L2,4 Z M16,4 L18,4 L18,14 L16,14 L16,4 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarousel);
export default __webpack_public_path__ + "static/media/icon-carousel.9a991a0151fce1bfbb4796f280589261.svg";
export { ForwardRef as ReactComponent };